import {combineReducers} from 'redux';
import {menu, RuntimeMenuState} from './menu';
import {loginStep, RuntimeLoginStepState} from './loginStep';
import {theme, ThemeState} from './theme';
import {news, NewsState} from './news';

export interface RuntimeState {
  menu: RuntimeMenuState;
  loginStep: RuntimeLoginStepState;
  theme: ThemeState;
  news: NewsState;
}

export const runtime = combineReducers({
  menu,
  loginStep,
  theme,
  news,
});
